module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[17]138.ab70bab.woff2";